/* eslint-disable @typescript-eslint/naming-convention */
export default {
    inForeignCountries: {
        Europe: [
            'Azoren',
            'Belgien',
            'Bulgarien',
            'Ceuta',
            'Dänemark',
            'Estland',
            'Finnland',
            'Frankreich',
            'Französisch Guayana',
            'Gibraltar',
            'Griechenland',
            'Großbritannien',
            'Guadeloupe',
            'Irland',
            'Island',
            'Italien',
            'Kanarische Inseln',
            'Kroatien',
            'La Reunion',
            'Lettland',
            'Liechtenstein',
            'Litauen',
            'Luxemburg',
            'Madeira',
            'Malta',
            'Martinique',
            'Mayotte',
            'Melilla',
            'Niederlande',
            'Norwegen',
            'Österreich',
            'Polen',
            'Portugal',
            'Rumänien',
            'Saint-Barthélemy',
            'Saint-Martin',
            'Schweden',
            'Slowakei',
            'Slowenien',
            'Spanien',
            'Tschechien',
            'Ungarn',
            'Ukraine',
            'Zypern',
        ],
        Truschcan: [
            'Andorra',
            'Färöer Inseln',
            'Guernsey (GB)',
            'Isle of Man (GB)',
            'Jersey (GB)',
            'Kanada',
            'Monaco',
            'Schweiz',
            'Türkei',
            'USA',
        ],
        RowPreferred: [
            'Afghanistan',
            'Ägypten',
            'Albanien',
            'Algerien',
            'Anguilla',
            'Antigua &Barbuda',
            'Argentinien',
            'Armenien',
            'Aruba',
            'Aserbaidschan',
            'Australien',
            'Bahamas',
            'Bahrain',
            'Bangladesch',
            'Barbados',
            'Belize',
            'Benin',
            'Bermuda',
            'Bosnien-Herzegowina',
            'Botswana',
            'Brasilien',
            'Britische Jungferninseln',
            'Brunei',
            'Burkina Faso',
            'Cayman Inseln',
            'Chile',
            'China',
            'Costa Rica',
            'Curacao (Niederländische Antillen)',
            'Demokratische Republik Kongo',
            'Dominica',
            'Dominikanische Republik',
            'Ecuador',
            'El Salvador',
            'Elfenbeinküste',
            'Fidschi',
            'Französisch-Polynesien',
            'Gabun',
            'Georgien',
            'Guam',
            'Guinea',
            'Guinea-Bissau',
            'Ghana',
            'Grönland',
            'Guatemala',
            'Guyana',
            'Honduras',
            'Hongkong',
            'Indien',
            'Indonesien',
            'Irak',
            'Iran',
            'Israel',
            'Jamaika',
            'Japan',
            'Jordanien',
            'Kambodscha',
            'Kamerun',
            'Kapverdische Inseln',
            'Kasachstan',
            'Katar',
            'Kenia',
            'Kirgistan',
            'Kolumbien',
            'Kongo (Republik)',
            'Kosovo',
            'Kuwait',
            'Laos',
            'Lesotho',
            'Libanon',
            'Liberia',
            'Macau',
            'Madagaskar',
            'Malawi',
            'Malaysia',
            'Malediven',
            'Mali',
            'Marokko',
            'Mauritius',
            'Mexiko',
            'Moldau',
            'Monaco',
            'Mongolei',
            'Mosambik',
            'Myanmar',
            'Nepal',
            'Neuseeland',
            'Nicaragua',
            'St. Maarten',
            'Niger',
            'Nigeria',
            'Nordmazedonien',
            'Oman',
            'Pakistan',
            'Panama',
            'Papua-Neuguinea',
            'Paraguay',
            'Peru',
            'Philippinen',
            'Puerto Rico',
            'Ruanda',
            'Russland',
            'Saudi Arabien',
            'Sambia',
            'Samoa',
            'Senegal',
            'Seychellen',
            'Serbien',
            'Sierra Leone',
            'Singapur',
            'Sri Lanka',
            'St. Lucia',
            'St. Kitts',
            'St. Vincent',
            'Südafrika',
            'Tadschikistan',
            'Tunesien',
            'Zentralafrikanische Republik',
            'Südkorea',
            'Süd-Sudan',
            'Surinam',
            'Swasiland',
            'Taiwan',
            'Tansania',
            'Thailand',
            'Togo',
            'Tonga',
            'Trinidad und Tobago',
            'Turks &Caicosinseln',
            'Tschad',
            'Uganda',
            'Uruguay',
            'Usbekistan',
            'Vanuatu',
            'Verein. Arab. Emirate',
            'Vietnam',
            'Weißrussland',
        ],
        Row2: [
            'Angola',
            'Äquatorialguinea',
            'Äthiopien',
            'Bhutan',
            'Bolivien',
            'Burundi',
            'Dschibuti',
            'Gabun',
            'Gambia',
            'Jemen',
            'Libyen',
            'Mauretanien',
            'Maritime Services',
            'Neukaledonien',
            'Roaming im Flugzeug',
            'Salomon-Inseln',
            'Simbabwe',
            'Turkmenistan',
            'Venezuela',
        ],
        WeltExp: [
            'Kiribati',
            'Kuba',
            'Namibia',
            'Norfolk Island',
        ],
    },
    toForeignCountries: {
        Europe: [
            'Belgien',
            'Bulgarien',
            'Dänemark',
            'Estland',
            'Finnland',
            'Frankreich',
            'Griechenland',
            'Großbritannien',
            'Irland',
            'Island',
            'Italien',
            'Kroatien',
            'Lettland',
            'Liechtenstein',
            'Litauen',
            'Luxemburg',
            'Malta',
            'Niederlande',
            'Norwegen',
            'Österreich',
            'Polen',
            'Portugal',
            'Rumänien',
            'Schweden',
            'Slowakei',
            'Slowenien',
            'Spanien',
            'Tschechien',
            'Ungarn',
            'Zypern',
        ],
        Türkei: [
            'Türkei',
        ],
        Welt: [
            'Australien',
            'Brasilien',
            'Hongkong',
            'Israel',
            'Japan',
            'Kanada',
            'Kolumbien',
            'Neuseeland',
            'San Marino',
            'Singapur',
            'Südkorea',
            'Schweiz',
            'USA',
        ],
    },
};
